import {ModuleNode} from '@backstage-components/base';
import {VFC} from 'react';
import {Alert, AlertIcon, Box} from '@chakra-ui/react';
import {SchemaType} from './ConfettiDefinition';

export type ConfettiProps = SchemaType;

export const ConfettiPreviewComponent: VFC<
  ModuleNode<'Confetti', ConfettiProps>
> = () => {
  return (
    <Box>
      <Alert status="info">
        <AlertIcon />
        Confetti: The confetti module will take up the width and height of its
        container. You will need to set up instructions in order to blast the
        confetti on a given trigger.
      </Alert>
    </Box>
  );
};
